import React, { useEffect, useState } from "react";
import useStyles from "./style";
import { Container } from "@material-ui/core";
import { Typography } from "@mui/material";
import ComponentDadosBasicos from "../../components/ComponentDadosBasicos";
import ComponentValoresConsolidados from "../../components/ComponentValoresConsolidados";
import ComponentConsolidado from "../../components/ComponentConsolidado";
import ComponentOperacaoDetalhada from "../../components/ComponentOperacaoDetalhada";
import jsonUtils from "../../utils/jsonUtils";

const RelatoriosDeConsulta = (props) => {
    const relatorio = props.relatorio;
    const operacoes = jsonUtils.getValor(
        "consultas.relatorio_financeiro.body.CREDCADASTRAL.RELATORIO_SCR.OPERACOES",
        relatorio
    );

    const total = jsonUtils.getValor(
        "consultas.relatorio_financeiro.body.CREDCADASTRAL.RELATORIO_SCR.OPERACOES.MODALIDADE.TOTAL",
        relatorio
    );

    const relatorio_financeiro = jsonUtils.getValor(
        "consultas.relatorio_financeiro.body",
        relatorio,
        true
    );

    if (!relatorio_financeiro) {
        return (
            <Container
                style={{
                    display: props.value !== props.index ? "none" : "block",
                }}
            >
                <Typography
                    variant="h5"
                    fontWeight="700"
                    color="#48484C"
                    marginLeft="20px"
                >
                    Sem dados financeiros
                </Typography>
            </Container>
        );
    }

    const classes = useStyles();

    return (
        <Container
            style={{ display: props.value !== props.index ? "none" : "block" }}
        >
            <div className={classes.margin}>
                <Typography
                    variant="h5"
                    fontWeight="700"
                    color="#48484C"
                    marginLeft="20px"
                >
                    Consulta - Dados financeiros
                </Typography>
            </div>

            <ComponentDadosBasicos relatorio={relatorio} />

            <ComponentValoresConsolidados relatorio={relatorio} />

            {/* <ComponentConsolidado relatorio={relatorio} /> */}

            {operacoes !== undefined && (
                <div className={classes.align}>
                    <Typography
                        variant="h5"
                        fontWeight="700"
                        color="#48484C"
                        marginTop="5px"
                        marginLeft="20px"
                    >
                        Operações
                    </Typography>
                    <p className={classes.parag}>
                        Detalhamento de todas as operações registradas, por modalidade e sub modalidade de crédito
                    </p>
                </div>
            )}

            {operacoes !== undefined && operacoes.map((operacao) => (
                <ComponentOperacaoDetalhada key={total} operacao={operacao} />
            ))}

        </Container>
    );
};

export default RelatoriosDeConsulta;
